import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  CULTURE_CHAOS_LEVELS,
  CULTURE_TEMPERAMENTS,
  CULTURE_EXPANSION_DRIVES
} from '../../../constants/culture.constants';

interface CultureEntry {
  azgaarId?: number;
  name: string;
  temperament: string;
  expansionDrive: string;
  notes: string;
}

@Component({
    selector: 'app-cultures-step',
    templateUrl: './cultures-step.component.html',
    styleUrls: ['./cultures-step.component.scss'],
    standalone: false
})
export class CulturesStepComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  chaosLevels = CULTURE_CHAOS_LEVELS;
  temperaments = CULTURE_TEMPERAMENTS;
  expansionDrives = CULTURE_EXPANSION_DRIVES;

  mapName = '';
  cultureChaosLevel = '';
  culturesList: CultureEntry[] = [];

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';
      this.cultureChaosLevel = state.cultureChaosLevel || '';

      // Initialize cultures from state, mapping prefilled data
      if (state.cultures && state.cultures.length > 0) {
        this.culturesList = state.cultures.map((c: any) => ({
          azgaarId: c.azgaarId || c.azgaar_id,
          name: c.name,
          temperament: c.temperament || '',
          expansionDrive: c.expansionDrive || '',
          notes: c.notes || ''
        }));
      } else {
        let extractedCultures: CultureEntry[] = [];
        if (state.mapJson) {
          const json = state.mapJson;
          const rawCultures = json.cultures || json.pack?.cultures || [];
          extractedCultures = rawCultures
            .filter((c: any) => c && c.name && c.name !== 'Wild' && c.name.toLowerCase() !== 'none' && c.name !== 'Neutral')
            .map((c: any) => ({
              azgaarId: c.i,
              name: c.name,
              temperament: '',
              expansionDrive: '',
              notes: ''
            }));
        }

        if (extractedCultures.length > 0) {
          this.culturesList = extractedCultures;
        } else {
          this.culturesList = [
            { azgaarId: 1, name: 'Culture 1', temperament: '', expansionDrive: '', notes: '' },
            { azgaarId: 2, name: 'Culture 2', temperament: '', expansionDrive: '', notes: '' },
            { azgaarId: 3, name: 'Culture 3', temperament: '', expansionDrive: '', notes: '' }
          ];
        }
      }
      this.cdr.detectChanges();
    });
  }

  saveState(): void {
    this.stateService.updateState({
      cultureChaosLevel: this.cultureChaosLevel,
      cultures: this.culturesList
    });
  }

  onNext(): void {
    this.saveState();
    this.next.emit();
  }

  onBack(): void {
    this.saveState();
    this.back.emit();
  }
}
